module.exports = __webpack_public_path__ + "img/scotland.42cea563.svg";